import axios, { AxiosInstance } from "axios";
import tokenManager from "./tokenManager";
import tokenConstant from "service/constant/tokenConstant";
import routerConstant from "service/constant/routerConstant";

interface ITokenCheck {
  accessToken: string | null;
}

export default class AxiosManager {
  private static instance: AxiosManager | null = null;

  private static axiosInstance: AxiosInstance = axios.create({});

  public static getInstance(responseType?: any) {
    if (this.instance === null) {
      this.instance = new AxiosManager();
    }
    return this.axiosCustom(tokenManager.getAccessToken(), responseType);
  }

  private static axiosCustom(tokenCheck: ITokenCheck, responseType?: any) {
    this.axiosInstance.interceptors.request.use((config: any) => {
      if (
        config.url !== "/api/auth/producer/token/refresh" &&
        tokenCheck.accessToken
      ) {
        return {
          ...config,
          headers: {
            ...config.headers,
            "content-Type":
              "multipart/form-data; boundary=<calculated when request is sent>",
            Accept: "*/*",
            "Accept-Encoding": "gzip, deflate, br",
            Connection: "keep-alive",
          },
          responseType: responseType ? responseType : "json",
        };
      } else {
        return config;
      }
    });

    this.axiosInstance.interceptors.response.use(
      (res) => {
        return res;
      },
      (err) => {
        const originalRequest = err.config;

        return err;
      },
    );

    return this.axiosInstance;
  }
}
